export enum UploadType {
  APK = 'APK',
  IPA = 'IPA',
  AAB = 'AAB',
  Attachment = 'Attachment',
}
